import type { WidgetLocale } from '../../types/widgetLocale';

/** Локаль для `toLocaleDateString` / `toLocaleTimeString` */
export const getIntlLocale = (locale: WidgetLocale): string => (locale === 'en' ? 'en-US' : 'ru-RU');

/** Локаль для `Intl.DisplayNames` */
export const getLangLocale = (locale: WidgetLocale): string => (locale === 'en' ? 'en' : 'ru');
